module.exports = Object.assign(require('./Construction.json'), {
    visibility: true,
    locked: false,
    image: '/img/dashboard/konstruktion.jpg',
    defaultItems: {},
    orderStatuses: require('../OrderStatuses.js'),
    tabs: [
        require('./Tab0-MasterData.js'),
        require('./Tab1-Construction.js'),
        require('./Tab2-Model.js'),
        require('./Tab3-Scans.js'),
        // require('./Tab3-Addons.js'),
        require('./Tab4-Cart.js'),
    ]
});
